import { useEffect } from 'react';

import { URL_PARAMS_KEY } from '@/constants';
import { useLoginAuth } from '@/features/auth';
import { useLoginUserInfo } from '@/hooks/useLoginUserInfo';
import { useUrlParameter } from '@/hooks/useUrlParameter';
import { captureAdParams } from '@/utils/ad';

/**
 * ようこそ画面用 カスタムフック
 */
export const useWelcome = () => {
  const { findParams } = useUrlParameter();
  const { loginAuth } = useLoginAuth({
    redirectPath: findParams(URL_PARAMS_KEY.WELCOME.path),
  });
  const { resetState } = useLoginUserInfo();

  /**
   * マウント時の処理
   */
  useEffect(() => {
    // 広告パラメータをURLから取得し保存
    captureAdParams();

    // プラン情報を初期化
    resetState();

    // ログイン認証実行
    loginAuth();

    // マウント時の1度のみ実行したいので無効コメント追加
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
